import { render, staticRenderFns } from "./WidgetMasterTable.vue?vue&type=template&id=509a0652&"
import script from "./WidgetMasterTable.vue?vue&type=script&lang=js&"
export * from "./WidgetMasterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports